import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "skeleton__table__container" }
const _hoisted_2 = {
  key: 1,
  class: "skeleton__table__row skeleton__table__row--default"
}

import {toRef, withDefaults} from 'vue'
import SkeletonAnimation from './SkeletonAnimation.vue'

interface Props {
  default?: boolean,
  rows?: number,
  columns?: number,
}


export default /*#__PURE__*/_defineComponent({
  props: {
    default: { type: Boolean, default: true },
    rows: { default: 0 },
    columns: { default: 0 }
  },
  setup(__props: any) {

const props: Props = __props as { default: boolean, rows: number, columns: number }



const styleDefault = toRef(props, 'default')


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(styleDefault))
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.rows, (row) => {
          return (_openBlock(), _createElementBlock("div", {
            key: row,
            class: "skeleton__table__row"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column) => {
              return (_openBlock(), _createElementBlock("div", {
                key: column,
                class: _normalizeClass(["skeleton__table__column", { 'skeleton__table__column--first': column === 1 }])
              }, null, 2))
            }), 128))
          ]))
        }), 128))
      : (_openBlock(), _createElementBlock("div", _hoisted_2)),
    _createVNode(SkeletonAnimation)
  ]))
}
}

})